
export let volContainer = () => `<span class="controlbar-button is-unmute"></span>`;

export let soundOffBtn = () => `<a href="" role="button">${require('../../../svg/player-mute.svg')}</a> `;

export let soundOnBtn = () => `<a href="" style="display: none;" role="button">${require('../../../svg/player-unmute.svg')}</a>`;

export let volumeControl = () => {
    return `
<div class="controlbar-volume" style="transition: unset;">
    <div class="controlbar-volume-inner">
        <div class="controlbar-volume-duration">
            <span class="controlbar-volume-bar"></span>
        </div>
    </div>
</div>`;
};